import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// @ts-ignore
import { getCookie } from "utils/StorageVariables";

// @ts-ignore
import useDeviceType from "../../../Hooks/ResponsiveHook";

import { AssistantProvider } from "components/InputAreaAI";
import PlanShortcut from "components/PlanShortcut";
import Pagination from "components/Pagination";

// @ts-ignore
import { RetrieveMasterPlanDetails } from "Redux/RetrieveMasterPlan/action";

// @ts-ignore
import { UpdateLastStep } from "Redux/UpdateLastStep/action";

// @ts-ignore
import { UpdateGoal } from "Redux/UpdateGoal/action";

// @ts-ignore
import { GetPredefinedMetrics } from "Redux/GetPredefinedMetrics/action";

// @ts-ignore
import { GetCustomMetrics } from "Redux/CustomMetrics/action";

import _ from "lodash";

import { ACTIONS_PATH, MEASUREMENT_PATH } from "utils/routes";

import {
  Container,
  ContainerItem,
  TableContainer,
  TableHeadCol,
  Header,
  HeaderTop,
  HeaderCol,
  HeaderMeasurement,
  MeasurementWrapper,
  MeasurementTitle,
  Category,
  Area,
  Goal,
  LockedWrapper
} from "./styled";

// @ts-ignore
import StepLayout from "../StepLayout/index";

// @ts-ignore
import LockedOver from "components/LockedOver/LockedOver";

import PurposeItem from "./PurposeItem";
import MeasurementForm from "./MetricSelector";

const SortArr = (data: any[]) =>
  data?.sort(function (a, b) {
    return a?.goal?.priority - b?.goal?.priority;
  });

const Purpose = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const screenSizes = useDeviceType();
  const isMobile = screenSizes === "mobile";
  const isTablet = screenSizes === "iPad";

  const $stepLayoutRef = useRef(null);


  useEffect(() => {
    let MasterPlanId = getCookie("MasterPlanId");
    dispatch(RetrieveMasterPlanDetails(MasterPlanId));
    dispatch(GetPredefinedMetrics());
  }, []);

  // @ts-ignore
  const { masterPlanDetails } = useSelector((state) => state.RetrieveMasterPlanDetailsReducer);

  // @ts-ignore
  const { selectedGoalAction } = useSelector((state) => state.globalReducer);

  // @ts-ignore
  const { data: customMetrics } = useSelector((state) => state.customMetricsReducer);

  // @ts-ignore
  const { SelectedClient } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    if (SelectedClient !== null) {
      dispatch(GetCustomMetrics());
    }
  }, [SelectedClient]);

  const areas = SortArr(masterPlanDetails?.areas.filter((area: any) => !area.goal.completed) || []);

  const handleChange = (id: string | undefined, field: string, value: string, callback?: () => void) => {
    let findedObj = areas?.find((item: any) => item?.id === id);

    dispatch(UpdateGoal(findedObj.goal.id, {
      [field]: value
    }, callback));
  };

  const userData = JSON.parse(getCookie("userData"));

  const isLocked =
    selectedGoalAction?.is_private && userData?.id !== selectedGoalAction?.user;

  const handlePrev = () => {
    navigate(MEASUREMENT_PATH);
  };

  const handleNext = () => {
    const formData = new FormData();
    formData.append("step", 5 + '');
    dispatch(UpdateLastStep(formData));

    navigate(ACTIONS_PATH);
  };

  const HeaderContent = () => {
    return <TableHeadCol $width="17vw" $ml={"12px"}>Goal</TableHeadCol>
  };

  return (
    <StepLayout
      title="5. Purpose"
      header={(isMobile || isTablet) ? null : <HeaderContent />}
      onPrev={handlePrev}
      onNext={handleNext}
      pagination={
        <Pagination i={selectedGoalAction?.i} actionPlanData={areas} />
      }
      titlePosition={isMobile ? true : false}
      ref={$stepLayoutRef}
    >
      <AssistantProvider>
        <Container>
          <ContainerItem>
            <LockedWrapper>
              <TableContainer>
                <Header>
                  <HeaderCol>
                    <HeaderTop>
                      <Category>{selectedGoalAction?.goal?.category_name}</Category>
                      <Area>{selectedGoalAction?.name}</Area>
                    </HeaderTop>
                    <Goal>{selectedGoalAction?.goal?.goal_name}</Goal>
                  </HeaderCol>

                  <HeaderMeasurement>
                    <MeasurementWrapper>
                      <MeasurementTitle>Measurement</MeasurementTitle>

                      {selectedGoalAction && (
                        <MeasurementForm
                          item={selectedGoalAction}
                          index={0}
                          customMetrics={customMetrics || []}
                        />
                      )}
                    </MeasurementWrapper>
                  </HeaderMeasurement>
                </Header>

                <PurposeItem
                  item={selectedGoalAction}
                  userData={userData}
                  onChange={handleChange}
                />
              </TableContainer>

              {isLocked && (
                <LockedOver customContent="This Goal is private" width="50px" />
              )}
            </LockedWrapper>
          </ContainerItem>

          <PlanShortcut
            isVisible={masterPlanDetails?.viewed_masterplan_screen}
          />
        </Container>
      </AssistantProvider>
    </StepLayout>
  );
};

export default Purpose;
